import React from "react";
import { Switch, Route, Redirect, useLocation } from "react-router-dom";
import { Container } from "components/Layout";
const Home = React.lazy(() => import("containers/Home"));
const CookiePolicy = React.lazy(() => import("containers/CookiePolicy"));
const Login = React.lazy(() => import("./Login.js"));
const ForgotPassword = React.lazy(() =>
	import("containers/Auth/ForgotPassword.js")
);
const TermsConditions = React.lazy(() =>
	import("containers/Auth/TermsConditions.js")
);

function Authentication(props) {
	const location = useLocation();
	return (
		<Container>
			<Switch>
				<Route exact path="/">
					<Home />
				</Route>
				<Route exact path={`/user/login`} component={Login} />
				<Route
					exact
					path={`/user/forgot-password`}
					component={ForgotPassword}
				/>
				<Route
					exact
					path={`/user/terms-conditions`}
					component={TermsConditions}
				/>
				<Route
					exact
					path={`/user/signup`}
					component={React.lazy(() => import("./Signup.js"))}
				/>
				<Route exact path="/cookie-policy" component={CookiePolicy} />

				<Redirect
					to={{
						pathname: "/user/login",
						state: { initialPageRequest: location },
					}}
				/>
			</Switch>
		</Container>
	);
}
export default Authentication;
